export default __webpack_public_path__ + "ticket.png";